import { IonButton, IonContent, IonPage, useIonModal } from "@ionic/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import BotListComponent from "../components/BotList";
import Header from "../components/Header";
import { subscribeToLobby, useLobbiesStore } from "../stores/lobbies.store";
import LobbyCard from "../components/LobbyCard";
import JoinLobby from "./JoinLobby";
import FullSummary from "../components/FullSummary";

interface LobbyProps {
  lobbyId?: string;
}

const Lobby: React.FC<LobbyProps> = ({ lobbyId }) => {
  const navLobbyId = useParams<{ lobbyId: string }>().lobbyId;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [currentLobbyId, setCurrentLobbyId] = useState(lobbyId || navLobbyId);
  const lobby = useLobbiesStore(state =>
    state.lobbies.find(l => l.id === currentLobbyId)
  );

  const [showJoinLobby, dismissJoinLobby] = useIonModal(JoinLobby, {
    onDismiss: () => dismissJoinLobby(),
    lobby,
    navigateTo: (path: string) => console.log("Already on", path)
  });

  // TODO: Alternative approach?
  useEffect(() => {
    if (currentLobbyId && !lobby) {
      // console.log("Manual override", currentLobbyId);
      subscribeToLobby(currentLobbyId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!lobby) return null;

  return (
    <IonPage>
      <Header title={lobby?.name || "Lobby"} back={true} />
      <IonContent>
        <LobbyCard lobby={lobby} />
        <BotListComponent lobbyId={lobby.id} />
        {(lobby?.ended || lobby?.completed) && (
          <div className="w-screen p-2">
            <FullSummary key="temp" lobby={lobby} />
          </div>
        )}
        {!lobby?.started && (
          <div className="w-screen p-2">
            <IonButton
              color="primary"
              className="rounded-lg w-full"
              onClick={() => showJoinLobby()}
            >
              Enter Bot
            </IonButton>
          </div>
        )}
      </IonContent>
    </IonPage>
  );
};

export default Lobby;
